import { render, staticRenderFns } from "./CustomizationMenu.vue?vue&type=template&id=94387844&scoped=true"
import script from "./CustomizationMenu.vue?vue&type=script&lang=js"
export * from "./CustomizationMenu.vue?vue&type=script&lang=js"
import style0 from "./CustomizationMenu.vue?vue&type=style&index=0&id=94387844&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94387844",
  null
  
)

export default component.exports